<template>
  <div >
    <canvas   :id="id"></canvas>

  </div>

</template>
<script>

  export default {

    data () {
      return {
        id:"chartjs"+Math.random(),
        items: [],
        months: [],
        colors: [],
        nums:[],
        chart:null,
        textlabel: '',
          chartId: [],
          myRoute: null,
      }
    },
    mounted () {
      Chart.register(ChartDataLabels);

    },
    methods: {

        chartRender () {
          var self = this
console.log('chat render called')
          // var canvasP = document.getElementById("line-chart");
          const ctx = document.getElementById(''+this.id);
        if(self.chart!=null){
          self.chart.destroy();
        }
          self.chart = new Chart(ctx, {
            type: 'pie',
            data: {

              labels: self.months,
              datasets: [{
                label: self.textlabel,
                data: self.nums,
                      backgroundColor: self.colors,
                      // borderColor: 'rgba(255, 99, 132, 1)',
                borderWidth: 1
              }]
            },
            options: {
              // scales: {
              //   y: {
              //     beginAtZero: true
              //   }
              // },
                  legend:{
                      display: false,
                      labels:{
                          // fontSize: 12,

                          // fontFamily: 'IRANSans'
                      }
                  },
                  title: {
                      display: true,
                      text: self.textlabel,
                      fontFamily: 'IRANSans',
                      padding: 40,
                      fontSize: 16,
                      borderThickness: 2,
                  },
                  plugins: {
                    legend: {
                      display: true,
                    },
                      datalabels: {
                        formatter: function(value, context) {
                          if(value!=0){
                            return context.chart.data.labels[context.dataIndex]+"("+value+")";
                            // return "salam"+"("+value+")";
                          }else{
                            return  ""
                          }
                        },
                        font: {
                          size: 14,
                          family:'IRANSans'
                        },
                          labels: {

                              title: {
                                  align: 'right',
                                  anchor: 'center',
                                  offset:0,
                                rotation:45,
                                clamp :true,
                              }
                          }
                      }
                  },
                  onClick:this.handle,
                responsive: true,

                maintainAspectRatio: false,
                cutoutPercentage: 80,
                // scales: {
                //
                //   y: {
                //     type: 'time',
                //
                //     height: 80,
                //     gridLines: {
                //       color: 'transparent',
                //       zeroLineColor: 'transparent',
                //     },
                //     ticks: {
                //       suggestedMin: 10,
                //       suggestedMax: 10,
                //       fontStyle: 0,
                //       fontSize: 14,
                //
                //       display: 'inline-block',
                //       width: 5,
                //       height: 80,
                //       lineHeight: 2
                //
                //     }
                //   },
                //   x: {
                //     type: 'pie',
                //
                //     categoryPercentage: 0.1,
                //     barPercentage: 1.0,
                //     ticks: {
                //       fontFamily: 'IRANSans',
                //       fontSize: 14,
                //       width: 5
                //     }
                //   }
                // },
                layout: {
                  padding: {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                  }
                },
            }
          });

            // var myPieChart = this.renderChart({
            //
            //   labels: self.months,
            //
            //   datasets: [{
            //
            //       label: self.textlabel,
            //       backgroundColor: 'rgba(255, 99, 132, 0.2)',
            //       borderColor: 'rgba(255, 99, 132, 1)',
            //       borderWidth: 2,
            //       // lineTension: 0.1,
            //       fill: true,
            //       responsive: true,
            //
            //       data: self.nums
            //     },
            //
            //   ],
            //
            // },
            //   {
            //     legend:{
            //         display: true,
            //         labels:{
            //             // fontSize: 12,
            //
            //             // fontFamily: 'IRANSans'
            //         }
            //     },
            //     title: {
            //         display: true,
            //         text: self.textlabel,
            //         fontFamily: 'IRANSans',
            //         padding: 40,
            //         fontSize: 16,
            //         borderThickness: 2,
            //     },
            //     plugins: {
            //         datalabels: {
            //             labels: {
            //                 title: {
            //                     align: 'top',
            //                     anchor: 'end',
            //                     offset: 0,
            //                 }
            //             }
            //         }
            //     },
            //     onClick:this.handle,
            //   responsive: true,
            //
            //   maintainAspectRatio: false,
            //   cutoutPercentage: 80,
            //   scales: {
            //
            //     yAxes: [{
            //
            //       height: 80,
            //       gridLines: {
            //         color: 'transparent',
            //         zeroLineColor: 'transparent',
            //       },
            //       ticks: {
            //         suggestedMin: 10,
            //         suggestedMax: 10,
            //         fontStyle: 0,
            //         fontSize: 14,
            //
            //         display: 'inline-block',
            //         width: 5,
            //         height: 80,
            //         lineHeight: 2
            //
            //       }
            //     }],
            //     xAxes: [{
            //
            //       categoryPercentage: 0.1,
            //       barPercentage: 1.0,
            //       ticks: {
            //         fontFamily: 'IRANSans',
            //         fontSize: 14,
            //         width: 5
            //       }
            //     }]
            //   },
            //   layout: {
            //     padding: {
            //       // left: 30,
            //       right: 30,
            //       top: 0,
            //       bottom: 50
            //     }
            //   },
            // })
        },
        handle (point, event) {
            const item = event[0]
            console.log("iteeem", item.index);

            console.log("liiink",this.id)
            // this.$router.push({ path: `/queue-information/${this.id[item._index]}` })
        },
    },
    watch : {

    },


  }
</script>

